import { render, staticRenderFns } from "./NewUserBusiness.vue?vue&type=template&id=1e2bb4da&"
import script from "./NewUserBusiness.ts?vue&type=script&lang=ts&"
export * from "./NewUserBusiness.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports